module.exports = __webpack_public_path__ + "img/rwanda.2a59b860.svg";